const DATE_TYPE = Object.freeze({
  BACKEND: "MM/DD/YYYY",
});

export {DATE_TYPE}




// WEBPACK FOOTER //
// ./src/enums/dateType.js